import { render } from "./positions.vue?vue&type=template&id=c74582f0"
import script from "./positions.vue?vue&type=script&lang=js"
export * from "./positions.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/host/imc/tender/dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"vue/js/components/reduction/sale/positions.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "c74582f0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('c74582f0', __exports__)) {
    console.log('reload')
    api.reload('c74582f0', __exports__)
  }
  
  module.hot.accept("./positions.vue?vue&type=template&id=c74582f0", () => {
    console.log('re-render')
    api.rerender('c74582f0', render)
  })

}


export default __exports__